import { useEffect, useMemo, useState } from "react";
import { toast } from "sonner";
import api, { API } from "@/lib/api";
import { FileText, Download } from "lucide-react";

export async function openAuthedPdf(path, headers, filename) {
  const res = await fetch(`${API}${path}`, { headers });
  if (!res.ok) throw new Error("pdf");
  const url = URL.createObjectURL(await res.blob());
  const w = window.open(url, "_blank");
  if (!w) { const a = document.createElement("a"); a.href = url; a.download = filename; a.click(); }
}

export default function StatementsList({ family = false, familyToken }) {
  const [months, setMonths] = useState([]);
  const [busy, setBusy] = useState("");
  const headers = useMemo(() => (family ? { "X-Family-Token": familyToken } : { Authorization: `Bearer ${localStorage.getItem("kindred_token")}` }), [family, familyToken]);

  useEffect(() => {
    const p = family ? fetch(`${API}/family/statements`, { headers }).then((r) => r.json()) : api.get("/statements/mine").then((r) => r.data);
    p.then((d) => setMonths(Array.isArray(d) ? d : [])).catch((err) => console.warn("Statements unavailable:", err));
  }, [family, headers]);

  const open = async (m) => {
    setBusy(m.month);
    try { await openAuthedPdf(`${family ? "/family/statements" : "/statements"}/${m.month}.pdf?tz_offset=${new Date().getTimezoneOffset()}`, headers, `kindred-statement-${m.month}.pdf`); }
    catch { toast.error("Couldn't open the statement. Please try again."); }
    finally { setBusy(""); }
  };

  if (months.length === 0) return null;
  return (
    <section data-testid="statements-list" className="mt-10">
      <div className="flex items-center gap-2 mb-3"><FileText className="w-6 h-6 text-[#2E7D6B]" /><h2 className="text-2xl font-display font-bold text-slate-900">{family ? "Monthly statements" : "My statements"}</h2></div>
      <p className="text-slate-600 mb-4">Large-print monthly summaries of visits, thank-yous and money spent.</p>
      <div className="flex flex-wrap gap-3">
        {months.map((m) => (
          <button key={m.month} data-testid={`statement-${m.month}`} onClick={() => open(m)} disabled={busy === m.month}
            className="flex items-center gap-2 bg-white border-2 border-[#E2D9CE] hover:border-[#2E7D6B] disabled:opacity-60 text-slate-800 font-semibold px-4 min-h-[48px] rounded-xl">
            <Download className="w-4 h-4 text-[#2E7D6B]" /> {busy === m.month ? "Preparing…" : m.label}
          </button>
        ))}
      </div>
    </section>
  );
}
